import type { ListingsSorting, TransactionType } from '@lib/components'

export const REPLY_SELECT_SORT_LABEL_MAP = {
  '-id': 'MostRecent',
  '+id': 'LeastRecent',
  '-priceEUR': 'MostExpensive',
  '+priceEUR': 'LeastExpensive',
} as const satisfies Record<ListingsSorting, string>

export const REPLY_SELECT_TRANSACTION_LABEL_MAP = {
  buy: 'Buy',
  rent: 'Rent',
} as const satisfies Record<TransactionType, string>
